import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import HeartRunnerProfileComponent from '../components/heartRunnerProfileComponent';
import { loggedIn, logout, logOutHeartRunner,getOrganizationID,getUserID,getProfile } from '../../../HeartRunnerLogin/actions/heartRunnerLoginAction'
import { updateProfileSettings,updateStatusSettings,updatePasswordSettings,fetchProfileSettingsDetail } from '../actions/heartRunnerprofileSettingsAction';

class HeartRunnerProfileContainer extends Component {
    

   

    updateProfileSettings=(formData)=>{
        //debugger
        this.props.actions.updateProfileSettings(
            formData,
            this.props.dispatch
        )

    }
    updateStatusSettings=(formData)=>{
        
        this.props.actions.updateStatusSettings(
            formData,
            this.props.dispatch
        )

    }
    updatePasswordSettings=(formData)=>{
        this.props.actions.updatePasswordSettings(
            formData,
            this.props.dispatch
        )
        
    }
    componentWillMount() {
        
        if (loggedIn(this.props.login.userid_token)) {
            let UserId=getUserID();
            //let UserId=13;
            this.props.actions.fetchProfileSettingsDetail(
                UserId,
                this.props.dispatch
            )
            }
            else {
                logout();
                this.props.actions.logOutHeartRunner();
                this.props.history.push('/heartrunnerlogin');
            }
        
        
    }
    render() {
        return (
            <div className="agile-grids">
                <div className="grids">
                    <div className="container">
                        <div className="row">
                            <HeartRunnerProfileComponent                                 
                                adminInfo={this.props.login.adminInfo}
                                updateProfileSettings={this.updateProfileSettings}
                                updatePasswordSettings={this.updatePasswordSettings}
                                updateProfileInfo={this.props.updateProfileInfo}
                                updateStatusSettings={this.updateStatusSettings}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            logOutHeartRunner,
            updateProfileSettings,
            updatePasswordSettings,
            updateStatusSettings,
            fetchProfileSettingsDetail,
        }, dispatch)
    };
};

function mapStateToProps({ heartRunnerprofileSettingsReducer, heartRunnerLoginReducer }) {
    //let OrganizationID=heartRunnerLoginReducer.organizationId===0?getOrganizationID():heartRunnerLoginReducer.organizationId;
    let UserId=getUserID();
   
    return {
        updateProfileInfo: {
            isLoading: heartRunnerprofileSettingsReducer.isLoading,
            errorNumber: heartRunnerprofileSettingsReducer.errorNumber,
            errorMessage: heartRunnerprofileSettingsReducer.errorMessage,
            messageLabel: heartRunnerprofileSettingsReducer.errorMessage,
            statusCode: heartRunnerprofileSettingsReducer.statusCode,
            profileInfo: heartRunnerprofileSettingsReducer.profileInfo,
           // organizationId:OrganizationID,
           UserId:UserId
        },
        login: {
            authTokenId: heartRunnerLoginReducer.authTokenId,
            adminId: heartRunnerLoginReducer.adminId,
            userName:heartRunnerLoginReducer.userName,
           // organizationId:OrganizationID,
            adminInfo:heartRunnerLoginReducer.adminInfo,

        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeartRunnerProfileContainer))